import React, { useEffect, useRef, useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import axios from 'axios';
import { Toast } from 'primereact/toast';
import { RadioButton } from "primereact/radiobutton";
import { useFormik } from 'formik';
import { Dropdown } from 'primereact/dropdown';
import { ColorPicker } from 'primereact/colorpicker';
import { Api } from '../../../services/api';
import { ConfirmDialog, } from 'primereact/confirmdialog';
import { MultiSelect } from 'primereact/multiselect';
import { FaTrash, FaUserLock } from 'react-icons/fa';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import "./Projectmanager.css";
import { BiPlusMedical } from 'react-icons/bi';
import { FileUpload } from 'primereact/fileupload';
import { HiPencilAlt } from "react-icons/hi";

const Projectmanager = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [globalFilter, setGlobalFilter] = useState('');
  // ___________________________________
  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
    useState(false);
  // ___________________________________
  const [users, setUsers] = useState([]);

  const [type, setType] = useState('Add');
  const [userId, setUserID] = useState('');
  const [pmIdForDelete, setPmIdForDelete] = useState('');
  const [roles, setRoles] = useState([]);
  const [division, setDivision] = useState([]);
  const [searchRole, setSearchRole] = useState([]);
  const toast = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [supervisor_id, setSupervisor_id] = useState([]);
  const [loginUsersRole, setLoginUsersRole] = useState(0);
  const [loginUsersID, setLoginUsersID] = useState(0);
  const [isPasswordChangeModalOpen, setIsPasswordChangeModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [allSupervisors, setAllSupervisors] = useState([]);
  const [divisionLBAndBR, setDivisionLBAndBR] = useState([]);

  const formik = useFormik({
    initialValues: {
      first_name: '',
      last_name: '',
      phone_number: '',
      email: '',
      address: '',
      role_id: '',
      access_level: '',
      color_code: 'FF0000',
      status: '',
      password: '',
      division: '',
      supervisor_id: '',
      billableRate: '',
      labourBurden: '',
      image: null,
      divisionLBAndBR: [],
    },

    validate: (data) => {
      let errors = {};
      if (!data.first_name) {
        errors.first_name = 'First Name is required.';
      }
      if (!data.last_name) {
        errors.last_name = 'Last Name is required.';
      }
      if (!data.email) {
        errors.email = 'Email is required.';
      }
      if (!data.role_id) {
        errors.role_id = 'Role is required.';
      }
      if (!data.password) {
        errors.password = 'password is required.';
      }
      return errors;
    },

    onSubmit: (data) => {
    
      const token = localStorage.getItem('authToken');
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };
      var url = Api.API_BASE_URL + 'add-users';
      if (type == "Edit") {
        url = Api.API_BASE_URL + 'update-users/' + userId;
      }
      data.created_by = localStorage.getItem('user_id');
      data.updated_by = localStorage.getItem('user_id');
      data.userId = localStorage.getItem('user_id');
      fetch(url, {
        method: "POST",
        headers:headers,
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((Josn) => {
          if (Josn.error != '') {
            toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });


          } else {
            // console.log(data.image);
            localStorage.setItem('image', data.image);
            toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
            closeModal();
            getUser();
           // window.location.reload();
          }

        })
        .catch((error) => {
          console.error("Error:", error);
        });

      console.log(data);
    }
  });
  const formikForeget = useFormik({
    initialValues: {
      user_id: '',
      password: '',
      confPassword: '',
      email: '',
      first_name: '',
      last_name: '',
      role: '',
      customMessage: '',
    },

    validate: (data) => {
      let errors = {};

      if (!data.password) {
        errors.password = 'password is required.';
      }
      if (!data.confPassword) {
        errors.confPassword = 'password is required.';
      }
      if (data.confPassword != data.password) {
        errors.confPassword = 'password and confirm password should be same.';
        errors.password = 'password and confirm password should be same.';
      }
      if (!data.customMessage) {
        errors.customMessage = 'message is required.';
      }
      return errors;
    },
    onSubmit: async (data) => {
      console.log(JSON.stringify(data));
      data.role = loginUsersRole;
    
      const url = Api.API_BASE_URL + 'update-password-users';
      const token = localStorage.getItem('authToken'); // Retrieve token
    
      const headers = {
        'Authorization': token ? `Bearer ${token}` : '', // Include token if available
        'Content-Type': 'application/json', // Specify JSON content
      };
    
      try {
        const response = await axios.post(url, data, { headers });
        const responseData = response.data;
    
        if (responseData.error !== '') {
          toast.current.show({ severity: 'error', summary: 'Error', detail: responseData.error });
        } else {
          toast.current.show({ severity: 'success', summary: 'Success', detail: responseData.result });
          setIsPasswordChangeModalOpen(false);
          getUser(); // Call getUser to refresh user data
        }
      } catch (error) {
        console.error('Error updating password:', error);
      }
    },
  });

  const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);
  const isFormFieldInvalidForget = (name) => !!(formikForeget.touched[name] && formikForeget.errors[name]);

  const getFormErrorMessage = (name) => {
    return isFormFieldInvalid(name) ? <small className="p-error">{formik.errors[name]}</small> : <small className="p-error">&nbsp;</small>;
  };

  const openModal = () => {
    setType('Add');
    formik.resetForm();
    setDivisionLBAndBR([]);
    formik.setFieldValue('status', 'Y');
    // formik.setFieldValue('role_id', ['3']);
    // formik.setFieldValue('role_id', '3');

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsDeleteConfirmationModalOpen(false);
  };

  const openEditModal = (event) => {
    formik.resetForm();
    formik.setFieldValue('first_name', event.first_name);
    formik.setFieldValue('last_name', event.last_name);
    formik.setFieldValue('phone_number', event.phone_number);
    formik.setFieldValue('email', event.email);
    formik.setFieldValue('address', event.address);
    formik.setFieldValue('role_id', event.roles);
    // formik.setFieldValue('role_id', event.role_id);
    formik.setFieldValue('access_level', event.access_level);
    formik.setFieldValue('color_code', event.color_code);
    formik.setFieldValue('status', event.status);
    formik.setFieldValue('division', event.division);
    formik.setFieldValue('supervisor_id', event.supervisor_id);
    //  formik.setFieldValue('supervisor_id', response.data.result.find(user => user.user_id === event.supervisor_id).user_id); 
    formik.setFieldValue('password', 'event.password');
    formik.setFieldValue('billableRate', event.billableRate);
    formik.setFieldValue('labourBurden', event.labourBurden);
    formik.setFieldValue('divisionLBAndBR', event.divisionLBAndBR);
    formik.setFieldValue('image', event.image);
    setDivisionLBAndBR(event.divisionLBAndBR);

    setType('Edit');
    setUserID(event.user_id);
    setIsModalOpen(true);

  };



  useEffect(() => {
    console.log('Fetching projects...');
    getUser();
    getRoles();
    var user_id = localStorage.getItem('user_id');
    var role_id = localStorage.getItem('role_id');
    setLoginUsersID(user_id);
    setLoginUsersRole(role_id);
  }, []);

  const customBase64Uploader = async (event) => {
    // convert file to base64 encoded
    const file = event.files[0];

    const fileType = file.type;
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

    if (!allowedTypes.includes(fileType)) {
      alert('File format not supported. Only JPG, JPEG, and PNG are allowed.');
      return;
    }


    const reader = new FileReader();
    let blob = await fetch(file.objectURL).then((r) => r.blob()); //blob:url

    reader.readAsDataURL(blob);

    reader.onloadend = function () {
      let base64data = reader.result;
      // base64data = base64data.replace("data:image/png;base64,", "");
      formik.setFieldValue("image", base64data);
      console.log("base64data", base64data);
    };
  };

  const UserImage = (rowData) => {
    return (
      <div className='user-image'>
        <img
          src={rowData.image ? rowData.image : 'https://cdn-icons-png.flaticon.com/512/149/149071.png'}
          alt="Imagez"
          className="rounded-full "
          style={{ width: '40px', height: '40px' }}
        />
      </div>
    );
  }



  const getRoles = async () => {
    // Retrieve the token from localStorage
    const token = localStorage.getItem('authToken');
  
    // Create headers with token if it exists
    const headers = {
      'Authorization': token ? `Bearer ${token}` : ''
    };
  
    // Make the GET request with token in the Authorization header
    try {
      const response = await axios.get(Api.API_BASE_URL + 'get-all-active-role', { headers });
      setRoles(response.data.result);
      console.log(response.data.result);
    } catch (error) {
      console.error('Error fetching roles:', error);
    }
  };
  


  const getUser = async () => {
    // Retrieve the token from localStorage
    const token = localStorage.getItem('authToken');
  
    // Create headers with token if it exists
    const headers = {
      'Authorization': token ? `Bearer ${token}` : ''
    };
  
    try {
      // Make the GET request with token in the Authorization header
      const response = await axios.get(Api.API_BASE_URL + 'get-all-users', { headers });
  
      // Handle the response
      setUsers(response.data.result);
      setAllSupervisors(response.data.result);
      setSearchRole(response.data.result);
      setDivision(response.data.division);
      setSupervisor_id(response.data.supervisor_id);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching users:', error);
      setIsLoading(false);
    }
  };
  

  const handleDeleteProject = (pmId) => {
    setPmIdForDelete(pmId);
    setIsDeleteConfirmationModalOpen(true);
  }

  const confirmDelete = async () => {
    setIsLoading(true);
    
    const data = {
      user_id: pmIdForDelete
    };
  
    // Retrieve the token from localStorage
    const token = localStorage.getItem('authToken');
  
    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
  
    try {
      // Make the POST request with token in the Authorization header
      const response = await fetch(Api.API_BASE_URL + 'delete-users/' + pmIdForDelete, {
        method: 'GET',
        headers: headers,
        // body: JSON.stringify(data)
      });
  
      const result = await response.json();
      setIsLoading(false);
      
      console.log(result);
      if (result.error) {
        toast.current.show({ severity: 'error', summary: 'Error', detail: result.error, life: 3000 });
       
      } else {
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'User deleted successfully', life: 3000 });
        getUser();
        setIsDeleteConfirmationModalOpen(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error('Error deleting user:', error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while deleting the user', life: 3000 });
    }
  };
  

  // ---------------------------------------------------------------------------------
  const openForgetPasswordModal = (event) => {
    formikForeget.setFieldValue('user_id', event.user_id);
    setUserID(event.user_id);
    formikForeget.setFieldValue('first_name', event.first_name);
    formikForeget.setFieldValue('last_name', event.last_name);
    formikForeget.setFieldValue('phone_number', event.phone_number);
    formikForeget.setFieldValue('email', event.email);
    setIsPasswordChangeModalOpen(true);
  }
  const actionBodyTemplate = (rowData) => {

    var isAdmin =    localStorage.getItem('isAdmin');
   
    return (
      <React.Fragment>

        <div onClick={(e) => e.stopPropagation()}>
          {isAdmin == 'Y' ? <FaUserLock onClick={() => openForgetPasswordModal(rowData)} style={{ color: 'darkblue', marginRight: '10px' }} /> : null}
          {/* {loginUsersRole == 1 || loginUsersRole == 2 || loginUsersRole == 12 || loginUsersRole == 13 ? <FaUserLock onClick={() => openForgetPasswordModal(rowData)} style={{ color: 'darkblue', marginRight: '10px' }} /> : null} */}
          <FaTrash onClick={() => handleDeleteProject(rowData.user_id)} style={{ color: 'darkred' }} />
        </div>
      </React.Fragment>
    );
  };

  const searchrole = (searchValue) => {

    setUsers([]);
    const searchResult = searchRole.filter((item) =>
      item.first_name.toLowerCase().includes(searchValue.toLowerCase())
    );
    setUsers(searchResult);
    console.log(searchResult)
  }

  const header = (
    <div className="flex flex-wrap align-items-center justify-content-between m-0">
      <h4 className="m-0 px-2 table-header">Manage Users</h4>
      <div>
        <span className="p-input-icon-left">
          <InputText
            className="input-field"
            type="search"
            placeholder="Search..."
            // value={globalFilter}
            onChange={(e) => searchrole(e.target.value)}
          />
        </span>
        <button type="button" title='Add a new project' style={{ cursor: 'pointer' }} onClick={openModal} className="custom-button m-2" >
          <div className='flex gap-2 px-1 py-1' style={{ alignItems: 'center' }}>
            <BiPlusMedical size={14} />
            <span> ADD </span>
          </div>
        </button>
      </div>

    </div>
  );

  const showColor = (showColor) => {
    return (
      <div className="p-d-flex p-ai-center" style={{textAlign:'center', alignItems:'center'}}>

        <div className="p-d-block p-ml-2 p-px-3 " style={{ backgroundColor: '#' + showColor, width: "50px", height: "20px",  }}></div>
      </div>
    )
  }

  const onRowSelect = (e) => {
    const rowData = e.data;
    openEditModal(rowData);
  };

  const showDivisionName = (title, id) => {


    for (let index = 0; index < roles.length; index++) {
      if (id == roles[index].id) {
        title += ' ' + roles[index].name;
      }

    }
    return title;

  }
  const divisionLBAndBRCheckData = (id) => {
    for (let index = 0; index < divisionLBAndBR.length; index++) {

      if (id == divisionLBAndBR[index].id) {
        return index;
      }
    }
    return -1;
  }


  return (
    <>
      <div className="pagee-container mt-2">
        <Toast ref={toast} />
        <ConfirmDialog />
        <div className="pagination-datable-height">
          {isLoading ? (
            <div className="loading-spinner">
              Loading...
              <div className="spinner"></div>
            </div>
          ) : (

            <DataTable
              value={users}
              paginator
              rows={13}
              key="_id"
              tableStyle={{ minWidth: '50rem' }}
              selectionMode="single"
              selection={selectedProduct}
              onRowSelect={onRowSelect}
              onSelectionChange={(e) => setSelectedProduct(e.value)}
              header={header}
              globalFilter={globalFilter || ''}
              emptyMessage="No records found"
            >

              <Column body={actionBodyTemplate} header="Action" exportable={false} style={{ width: '100px', textAlign: 'center' }}></Column>
              <Column header="Profile" body={UserImage}></Column>
              <Column field="first_name" header="First Name" ></Column>
              <Column field="last_name" header="Last Name"></Column>
              <Column field="phone_number" header="Phone Number"></Column>
              <Column field="email" header="Email"></Column>
              <Column field="address" header="Address"></Column>
              <Column field="role_name" header="Role"></Column>
              <Column field="divisionName" header="Division"></Column>
              <Column field="created_at" header="Created At"></Column>
              <Column field="created_by" header="Created By"></Column>
              <Column field="updated_at" header="Updated At"></Column>
              <Column field="updated_by" header="Updated By"></Column>
              <Column field="color_code" header="Color Code" body={(e) => showColor(e.color_code)} ></Column>
            </DataTable>
          )}
        </div>
      </div>

      {/* // -------------------------------------------------------------------------------------- */}
      <Dialog header="" visible={isModalOpen} maximizable style={{ width: '50vw' }} dismissableMask="true" onHide={() => {
        setIsModalOpen(false);
        setSelectedProduct(null);
      }} >
        <div className='p-4 overflow-hidden'>
          <form onSubmit={formik.handleSubmit} className="" >
            <div className="formgrid grid">

              <div className="col-6">
                <label className='card-heading'>First Name</label>
                <InputText
                  id="first_name"
                  name="first_name"
                  value={formik.values.first_name}
                  onChange={(e) => {

                    formik.setFieldValue('first_name', e.target.value);
                  }}
                  className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('first_name') })} style={{ width: '100%' }}
                />
                 {/* <ErrorMessage name="first_name" component="div" className="error-message" /> */}
              </div>
              <div className="col-6">
                <label className='card-heading'>Last Name</label>
                <InputText
                  id="last_name"
                  name="last_name"
                  value={formik.values.last_name}
                  onChange={(e) => {
                    formik.setFieldValue('last_name', e.target.value);
                  }}
                  className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('last_name') })} style={{ width: '100%' }}
                />
              </div>

              <div className="col-6 pt-2">
                <label className='card-heading'>Address</label>
                <InputText
                  id="address"
                  name="address"
                  value={formik.values.address}
                  onChange={(e) => {
                    formik.setFieldValue('address', e.target.value);
                  }}
                  className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('address') })} style={{ width: '100%' }}
                />
              </div>

              <div className="col-6 pt-2">
                <label className='card-heading'>Email</label>
                <InputText
                  id="email"
                  name="email"
                  value={formik.values.email}
                  onChange={(e) => {
                    formik.setFieldValue('email', e.target.value);
                  }}
                  className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('email') })} style={{ width: '100%' }}
                />
              </div>

              {type === "Add" ? (<div className="col-6 pt-2">
                <label className='card-heading'>Password</label>
                <InputText
                  id="password"
                  name="password"
                  value={formik.values.password}
                  onChange={(e) => {
                    formik.setFieldValue('password', e.target.value);
                  }}
                  className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('password') })} style={{ width: '100%' }}
                />
              </div>) : (<div></div>)
              }

              <div className="col-6 pt-2">
                <label className='card-heading'>Phone Number</label>
                <InputText
                  id="phone_number"
                  name="phone_number"

                  value={formik.values.phone_number}
                  onChange={(e) => {
                    formik.setFieldValue('phone_number', e.target.value);
                  }}
                  className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('phone_number') })} style={{ width: '100%' }}
                />
              </div>

              <div className="col-6 pt-2">
                <label className='card-heading'>Supervisor</label>
                <Dropdown
                  optionValue='user_id'
                  id="supervisor_id"
                  name="supervisor_id"
                  placeholder="Select a Supervisor"
                  options={allSupervisors}
                  optionLabel={(e) => { return e.first_name + ' ' + e.last_name }}
                  value={formik.values.supervisor_id}

                  onChange={(e) => {

                    formik.setFieldValue('supervisor_id', e.value);
                  }}
                  className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('supervisor_id') })} style={{ width: '100%' }}
                />
              </div>

              <div className="col-6 pt-2">
                <label className='card-heading'>Role</label>
                <MultiSelect
                  optionValue='id'
                  id="role_id"
                  name="role_id"
                  placeholder="Select a Role"
                  options={roles}
                  optionLabel="name"

                  value={formik.values.role_id}

                  onChange={(e) => {

                    formik.setFieldValue('role_id', e.value);

                    /***division addd new role starrt */
                    var _array = [];

                    for (let index = 0; index < e.value.length; index++) {
                      var t = divisionLBAndBRCheckData(e.value[index]);
                      console.log('t--------', t);
                      if (t == -1) {
                        _array.push({ id: e.value[index], lbValue: '', lbTitle: 'Labour Burden', brValue: '', brTitle: 'Billable Rate' })
                      } else {
                        _array.push({ id: divisionLBAndBR[index].id, lbValue: divisionLBAndBR[index].lbValue, lbTitle: 'Labour Burden', brValue: divisionLBAndBR[index].brValue, brTitle: 'Billable Rate' })
                        console.log('ddddd-------', divisionLBAndBR[index])
                      }

                    }
                    formik.setFieldValue('divisionLBAndBR', _array);
                    formik.setFieldValue('division', e.value);
                     /***division addd new role starrt */
                  }}
                  className={classNames('p-2',)} style={{ width: '100%' }}
                />
              </div>

              {/* <div className="col-6 pt-2">
                <label className='card-heading'>Division</label>
                <MultiSelect
                  optionValue='id'
                  id="division"
                  name="division"
                  placeholder="Select a Division"
                  options={division}
                  optionLabel="title"
                  value={formik.values.division}
                  onChange={(e) => {

                    var _array = [];

                    for (let index = 0; index < e.value.length; index++) {
                      var t = divisionLBAndBRCheckData(e.value[index]);
                      console.log('t--------', t);
                      if (t == -1) {
                        _array.push({ id: e.value[index], lbValue: '', lbTitle: 'Labour Burden', brValue: '', brTitle: 'Billable Rate' })
                      } else {
                        _array.push({ id: divisionLBAndBR[index].id, lbValue: divisionLBAndBR[index].lbValue, lbTitle: 'Labour Burden', brValue: divisionLBAndBR[index].brValue, brTitle: 'Billable Rate' })
                        console.log('ddddd-------', divisionLBAndBR[index])
                      }

                    }
                    formik.setFieldValue('divisionLBAndBR', _array);
                    formik.setFieldValue('division', e.value);
                  }}
                  className={classNames('p-2')} style={{ width: '100%' }}
                />
              </div> */}

              {formik.values.divisionLBAndBR.length > 0 && (
                <div className='card-card formgrid grid p-2 my-4 m-2'>
                  {formik.values.divisionLBAndBR.map((item, index) => (
                    <div className="col-6 pt-2" key={index}>
                      <label className='card-heading'>
                        {showDivisionName(item.lbTitle, item.id)}
                      </label>
                      <InputText
                        id={item.id}
                        name={'lb-' + item.id}
                        value={formik.values.divisionLBAndBR[index].lbValue}
                        onChange={(e) => {
                          formik.setFieldValue(`divisionLBAndBR[${index}].lbValue`, e.target.value);
                        }}
                        className={classNames('p-2')}
                        style={{ width: '100%' }}
                      />
                    </div>
                  ))}

                  {formik.values.divisionLBAndBR.map((item, index) => (
                    <div className="col-6 pt-2" key={index}>
                      <label className='card-heading'>
                        {showDivisionName(item.brTitle, item.id)}
                      </label>
                      <InputText
                        id={item.id}
                        name={'lb-' + item.id}
                        value={formik.values.divisionLBAndBR[index].brValue}
                        onChange={(e) => {
                          formik.setFieldValue(`divisionLBAndBR[${index}].brValue`, e.target.value);
                        }}
                        className={classNames('p-2')}
                        style={{ width: '100%' }}
                      />
                    </div>
                  ))}
                </div>
              )}




              <div className="col-6 pt-2">
                <label className='card-heading'>Status</label>
                <div>
                  <RadioButton inputId="ingredient1" name="status" value="Y" onChange={(e) => formik.setFieldValue('status', e.target.value)} checked={formik.values.status === 'Y'} />
                  <label htmlFor="ingredient1" className="ml-2">Active</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <RadioButton inputId="ingredient2" name="status" value="N" onChange={(e) => formik.setFieldValue('status', e.target.value)} checked={formik.values.status === 'N'} />
                  <label htmlFor="ingredient2" className="ml-2">In-Active</label>
                </div>

              </div>


              <div className="col-6 pt-2  ">
                <div className='card-card p-2'>
                  <label className='card-heading'>Colors</label>
                  <div className="predefined-colors pt-2" style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                  }}>
                    {[
                      { color: '#FF0000', label: 'Red' },
                      { color: '#00FF00', label: 'Green' },
                      { color: '#0000FF', label: 'Blue' },
                      { color: '#FFFF00', label: 'Yellow' },
                      { color: '#FF00FF', label: 'Magenta' },
                      { color: '#00FFFF', label: 'Cyan' },
                      { color: '#800000', label: 'Maroon' },
                      { color: '#008000', label: 'Green' },
                      { color: '#000080', label: 'Navy' },
                      { color: '#808000', label: 'Olive' },
                      { color: '#800080', label: 'Purple' },
                      { color: '#008080', label: 'Teal' },
                      { color: '#C0C0C0', label: 'Gray' },
                      { color: '#999999', label: 'Dark Gray' },
                      { color: '#666666', label: 'Dark Gray' },
                      { color: '#333333', label: 'Very Dark Gray' },
                      { color: '#000000', label: 'Black' },
                      { color: '#FFFFFF', label: 'White' },
                    ].map((color, index) => (
                      <div
                        key={index}
                        style={{
                          width: 20,
                          height: 20,
                          backgroundColor: color.color,
                          borderRadius: '50%',
                          cursor: 'pointer',
                          margin: 2,
                        }}
                        onClick={() => {

                          console.log(color.color);

                          const colorCode = color.color.replace('#', '');
                          formik.setFieldValue('color_code', colorCode);
                        }}
                      />
                    ))}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                    <ColorPicker
                      id="color_code"
                      name="color_code"
                      value={formik.values.color_code}
                      onChange={(e) => {
                        console.log(e.target.value)
                        formik.setFieldValue('color_code', e.target.value);
                        // formik.handleChange('color_code');
                      }}
                      className={classNames('', { 'p-invalid': isFormFieldInvalid('color_code') })}
                      style={{ width: '50%', alignItems: 'center', justifyContent: 'center', marginRight: 0 }}
                    />
                    <HiPencilAlt size={20} />
                  </div>
                </div>
              </div>

              <div className="col-12 p-2 pt-4 " style={{ borderBottom: '1px solid black' }}>
                <h3 className="card-heading">User Image</h3>
              </div>

              <div className=' pt-2  flex-col'  style={{ display: 'block', margin: '0 auto' }}>
                {formik.values.image ?
                  <div className="col-12 p-2  ">
                    <img height={250} width={250} src={`${formik.values.image}`}  />
                  </div>
                  :  <div className="p-2 card-card">
                     <img height={250} width={250} src={`https://cdn-icons-png.flaticon.com/512/149/149071.png`} />
                  </div>
                }

                <div className="" style={{ display: 'flex', justifyContent:'center' }}>
                  <FileUpload mode="basic" name="demo[]" accept="image/*" className='m-2' chooseLabel="Choose File" onSelect={customBase64Uploader} style={{  fontSize: '18px', fontWeight: 'bold' }} />
                </div>
              </div>

              {/* {formik.values.image ?
                <div className="col-6 pt-2 card-card">
                  <img height={400} width={420} src={`${formik.values.image}`} />
                </div>
                : <img height={100} width={120} src={`https://cdn-icons-png.flaticon.com/512/149/149071.png`} />
              }

              <div className="col-6 pt-4">
                <FileUpload mode="basic" name="demo[]" accept="image/*" className='m-2' chooseLabel="Browse" onSelect={customBase64Uploader} style={{ height: '150px', fontSize: '18px', fontWeight: 'bold' }} />
              </div> */}





            </div>
            <div className=" flex flex-wrap justify-content-center mt-4">
              <Button label="Submit" type="submit" className='p-2 customSave-button' />
            </div>
          </form>
        </div>
      </Dialog>

      {/* // -------------------------------------------------------------------------------------- */}
      <Dialog header="" visible={isPasswordChangeModalOpen} maximizable style={{ width: '50vw' }} dismissableMask="true" onHide={() => setIsPasswordChangeModalOpen(false)}>
        <div className='card'>
          <form onSubmit={formikForeget.handleSubmit} className="" >
            <div className=" formgrid grid">

              <div className="col-6 pt-2">
                <label className='card-heading'>Password</label>
                <InputText
                  id="password"
                  name="password"
                  value={formikForeget.values.password}
                  onChange={(e) => {
                    formikForeget.setFieldValue('password', e.target.value);
                  }}
                  className={classNames('p-2 custom-input', { 'p-invalid': isFormFieldInvalidForget('password') })} style={{ width: '100%' }}
                />
              </div>
              <div className="col-6 pt-2">
                <label className='card-heading'>Confirm Password</label>
                <InputText
                  id="confpassword"
                  name="confpassword"
                  value={formikForeget.values.confPassword}
                  onChange={(e) => {
                    formikForeget.setFieldValue('confPassword', e.target.value);
                  }}
                  className={classNames('p-2 custom-input', { 'p-invalid': isFormFieldInvalidForget('confPassword') })} style={{ width: '100%' }}
                />
              </div>

              <div className="col-12 pt-2">
                <label className='card-heading'>Custom Message</label>
                <textarea
                  id="customMessage"
                  name="customMessage"
                  value={formikForeget.values.customMessage}
                  onChange={(e) => {
                    formikForeget.setFieldValue('customMessage', e.target.value);
                  }}
                  className={classNames('p-2 custom-input', { 'p-invalid': isFormFieldInvalidForget('customMessage') })} style={{ height: '10vh' }}
                />
              </div>

            </div>
            <div className="flex flex-wrap justify-content-center mt-4">
              <Button label="Submit" type="submit" className='p-2 customSave-button' />
            </div>
          </form>


        </div>
      </Dialog>


      {/* ---------------Delete Modal -------------------------- */}
      {isDeleteConfirmationModalOpen && (
        <div className="modal">
          <div className="small-modal-content">
            <div className="modal-headerx">
              <h5 className="modal-title">Delete Confirmation</h5>
              <button className="modal-closex" onClick={closeModal}>
                &times;
              </button>
            </div>
            <div className="modal-bodyx">
              <p>Are you sure you want to Delete this User?</p>
            </div>
            <div className="modal-footer-cancelx">
              <button className="cancel-buttonx" onClick={closeModal}>
                Cancel
              </button>
              <button className="delete-buttonx" onClick={confirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

    </>
  )
}

export default Projectmanager
